import { corporateCMSApi } from "~/Services";
import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
export const generateFields = (
  basePath: string,
  languages: { code: string; label: string; parseField: string }[],
  idx1: number
): ModuleFields[] => {
  return languages.flatMap((lang) => {
    const fields: ModuleFields[] = [];
    if (lang.parseField === "field_content_english") {
      fields.push({
        fieldName: `Image`,
        fieldValue: `${basePath}.cardData[${idx1}].image`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "image",
        name: `${lang.parseField}.${basePath}.cardData[${idx1}].image`,
        formType: "file",
        usedFileType: "image/*",
        label: `Image`,
        placeholder: `Select Image`,
        validation: { required: `Image is required` },
      });
    }
    fields.push(
      {
        fieldName: `Title (${lang.code})`,
        fieldValue: `${basePath}.cardData[${idx1}].title`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "content",
        name: `${lang.parseField}.${basePath}.cardData[${idx1}].title`,
        formType: "input",
        label: `Title (${lang.code})`,
        placeholder: `Enter Title ${lang.code}`,
        validation:
          lang.parseField === "field_content_english" ? { required: `Title ${lang.code} is required` } : undefined,
      },
      {
        fieldName: `Description (${lang.code})`,
        fieldValue: `${basePath}.cardData[${idx1}].description`,
        parseField: lang.parseField,
        className: "col-span-6",
        type: "content",
        name: `${lang.parseField}.${basePath}.cardData[${idx1}].description`,
        formType: "richText",
        label: `Description (${lang.code})`,
        placeholder: `Enter Description ${lang.code}`,
        validation:
          lang.parseField === "field_content_english"
            ? { required: `Description ${lang.code} is required` }
            : undefined,
      }
      // {
      //   fieldName: `Link (${lang.code})`,
      //   fieldValue: `${basePath}.cardData[${idx1}].link`,
      //   parseField: lang.parseField,
      //   className: "col-span-6",
      //   type: "content",
      //   name: `${lang.parseField}.${basePath}.cardData[${idx1}].link`,
      //   formType: "input",
      //   label: `Link (${lang.code})`,
      //   placeholder: `Enter Link ${lang.code}`,
      //   validation:
      //     lang.parseField === "field_content_english"
      //       ? { required: `Link ${lang.code} is required` }
      //       : undefined,
      // }
    );

    return fields;
  });
};
export const languages = [
  { code: "EN", label: "English", parseField: "field_content_english" },
  { code: "MS", label: "Malay", parseField: "field_content_malay" },
  { code: "ZH", label: "Mandarin", parseField: "field_content_mandarin" },
];
let url = `/api/page-content/all-fields?pageName=sustainability`;
export let getData: { [key in ModuleConfig]: ModuleFields[] } | null = null;
const fetchProfileData = async (): Promise<{ [key in ModuleConfig]: ModuleFields[] } | null> => {
  try {
    const res = await corporateCMSApi.get(url);
    const profileData = res.data;
    const fields1 =
      profileData?.[0]?.field_content_english?.data?.cardData?.map((item: any, index: number) =>
        generateFields("data", languages, index)
      ) || [];
    return {
      landing: fields1 as ModuleFields[],
    };
  } catch (error) {
    return null;
  }
};
export const getSustainabilityDrilldownData = async () => {
  if (!getData) {
    getData = await fetchProfileData();
  }
  return getData;
};
